const employeeKey = (employee) => {
	if (employee?.id == null) return null;
	return String(employee.id);
};

/**
 * Reescribe el orden guardado del grupo con el orden visible del modal.
 * Quien no está en la semana conserva su hueco. Quien entra nuevo se inserta
 * junto al vecino visible que el usuario le dejó, sin adelantar a los ocultos
 * que iban delante del primer puesto visible.
 */
export function mergeVisibleEmployeeOrder(fullOrder = [], visibleOrder = []) {
	const full = Array.isArray(fullOrder) ? fullOrder : [];
	const visible = Array.isArray(visibleOrder) ? visibleOrder : [];

	const fullIds = new Set(full.map(employeeKey).filter((id) => id != null));
	const visibleIds = new Set(
		visible.map(employeeKey).filter((id) => id != null)
	);
	const originalVisibleIds = new Set(
		full
			.map(employeeKey)
			.filter((id) => id != null && visibleIds.has(id))
	);

	const reorderedKnown = [];
	const seenKnown = new Set();
	visible.forEach((employee) => {
		const key = employeeKey(employee);
		if (key == null || !originalVisibleIds.has(key) || seenKnown.has(key)) {
			return;
		}
		seenKnown.add(key);
		reorderedKnown.push(employee);
	});

	let cursor = 0;
	const withSlots = full.map((employee) => {
		const key = employeeKey(employee);
		if (key == null || !originalVisibleIds.has(key)) return employee;
		return reorderedKnown[cursor++] || employee;
	});

	const placed = new Set(withSlots.map(employeeKey).filter((id) => id != null));
	const result = [...withSlots];

	visible.forEach((employee, index) => {
		const key = employeeKey(employee);
		if (key == null || placed.has(key) || fullIds.has(key)) return;

		const previous = visible
			.slice(0, index)
			.reverse()
			.find((candidate) => placed.has(employeeKey(candidate)));

		if (!previous) {
			const firstVisibleSlot = result.findIndex((candidate) =>
				originalVisibleIds.has(employeeKey(candidate))
			);
			if (firstVisibleSlot === -1) {
				result.push(employee);
			} else {
				result.splice(firstVisibleSlot, 0, employee);
			}
		} else {
			const insertAt = result.findIndex(
				(candidate) => employeeKey(candidate) === employeeKey(previous)
			);
			result.splice(insertAt + 1, 0, employee);
		}
		placed.add(key);
	});

	return result;
}
